import { autocompleteBrandsStyles } from "@insite/content-library/Widgets/Header/AutocompleteBrands";
import { autocompleteCategoriesStyles } from "@insite/content-library/Widgets/Header/AutocompleteCategories";
import { autocompleteContentStyles } from "@insite/content-library/Widgets/Header/AutocompleteContent";
import { autocompleteProductsStyles } from "@insite/content-library/Widgets/Header/AutocompleteProducts";
import { searchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Search from "@insite/mobius/Icons/Search";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

searchInputStyles.input = {
    sizeVariant: "default",
    iconProps: { src: Search },
    border: "rounded",
    cssOverrides: {
        formField: css`
            color: #000;
            input {
                border-radius: 100px !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        padding-bottom: 18px;
                    `,
                    css`
                        width: 100%;
                        padding-bottom: 18px;
                    `,
                    css`
                        width: 100%;
                        padding-bottom: 18px;
                    `,
                    css`
                        width: 100%;
                        margin-right: 16px;
                    `,
                    css`
                        width: 100%;
                        margin-right: 16px;
                    `,
                ])}
        `,
    },
};

searchInputStyles.popoverWrapper = {
    as: "div",
    _height: "auto",
    css: css`
        display: inline-flex;
        justify-content: flex-end;
        color: #000;
    `,
};

searchInputStyles.autocompleteColumnWrapper = {
    css: css`
        display: flex;
        width: 375px;
        max-width: calc(100% - 30px);
        padding: 20px;
        flex-direction: column;

        ${({ theme }: { theme: BaseTheme }) => {
            return breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    border-left: 1px solid rgba(0, 0, 0, 0.15);
                    width: 50%;
                    width: 50%;
                `,
                css`
                    border-left: 1px solid rgba(0, 0, 0, 0.15);
                    width: 50%;
                    width: 50%;
                `,
                css`
                    border-left: 1px solid rgba(0, 0, 0, 0.15);
                    width: 50%;
                    width: 50%;
                `,
            ]);
        }}

        b {
            color: #0679e3;
        }
    `,
};

autocompleteProductsStyles.headerText = {
    fontFamily: "Pancetta Pro",
    weight: "bold",
    css: css`
        text-align: left;
        margin-bottom: 5px;
    `,
};

autocompleteProductsStyles.container = {
    gap: 0,
    css: css`
        flex-drection: column;
        flex-grow: 0;
        margin-bottom: 16px;
        cursor: pointer;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
        border-radius: 3px;
        padding: 10px 0;
    `,
};

autocompleteProductsStyles.focusedContainer = {
    gap: 0,
    css: css`
        flex-grow: 0;
        margin-bottom: 16px;
        cursor: pointer;
        background-color: lightgray;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
        border-radius: 3px;
    `,
};

autocompleteProductsStyles.imageGridItem = {
    width: 3,
    css: css`
        max-width: 122px;
        max-height: 85px;
        flex-basis: 122px;
        padding: 0 10px;
    `,
};

autocompleteProductsStyles.image = {
    width: "100%",
    css: css`
        img {
            height: 100%;
            width: 100%;
            object-fit: contain;
        }
    `,
};

autocompleteProductsStyles.infoGridItem = {
    width: 9,
    css: css`
        height: 90px;
        flex-direction: column;
        max-width: calc(100% - 122px);
        flex-basis: calc(100% - 122px);
    `,
};

autocompleteProductsStyles.titleLink = {
    typographyProps: {
        fontFamily: "Pancetta Pro",
        weight: "bold",
        lineHeight: 1.16,
        ellipsis: true,
        css: css`
            width: 100%;
            text-align: left;
            margin: 0;

            span {
                color: #000;
            }
        `,
    },
    css: css`
        width: 100%;
    `,
};

autocompleteProductsStyles.erpNumberText = {
    ellipsis: true,
    color: "#666666",
    css: css`
        width: 100%;
        text-align: left;
        margin: 0;
    `,
};

autocompleteBrandsStyles.link = {
    typographyProps: {
        fontFamily: "Pancetta Pro",
        ellipsis: true,
        css: css`
            width: 100%;
            text-align: left;
            margin-bottom: 5px;
        `,
    },
    css: css`
        width: auto;
        overflow: hidden;
    `,
};

autocompleteCategoriesStyles.headerText = {
    fontFamily: "Pancetta Pro",
    weight: "bold",
    css: css`
        text-align: left;
        margin-bottom: 5px;
    `,
};

autocompleteContentStyles.headerText = {
    fontFamily: "Pancetta Pro",
    weight: "bold",
    css: css`
        text-align: left;
        margin-bottom: 5px;
    `,
};
